import * as modalActions from './modalActions'

/**
 * Loads the AppConfig from the local browser storage
 */
export function loadLocalAppConfig() {
  return {
    type: 'LOAD_LOCAL_APP_CONFIG'
  }
}

export function loadGlobalAppConfigAuth() {
  return {
    type: 'LOAD_GLOBAL_APP_CONFIG_AUTH'
  }
}

export function loadLobbyLoginConfig() {
  return {
    type: 'LOAD_LOBBY_LOGIN_CONFIG'
  }
}

export function loadLobbyDashboardConfig() {
  return {
    type: 'LOAD_LOBBY_DASHBOARD_CONFIG'
  }
}

export function loadTreatmentAppConfig() {
  return {
    type: 'LOAD_TREATMENT_APP_CONFIG'
  }
}

export function clearUiConfig(element, context) {
  return {
    type: `CLEAR_UI_CONFIG`,
    element,
    context
  }
}

/**
 * Updates values of the appConfig store object
 * @param  {String} [key]   Name of the appConfig property to update. Ex
 *                          HEADER_TEXT
 * @param  {any?} [value] Value to which the property should be updated.
 *                        Ex. "Baker Allergy and Asthma"
 */
export function updateAppConfig(key, value) {
  return {
    type: 'UPDATE_APP_CONFIG',
    value,
    key
  }
}

// wrapper for modal-framework openModal for backwards compatibility
export function showModal(title, content, closeable = true, opacity = null) {
  return modalActions.openModal(() => null, {
    title,
    content,
    closeable,
    opacity
  })
}

/**
 * update the api fail count
 * @param  {bool} [failure] True causes the count to increment. False resets
 *                          count to 0.
 */
export function apiFailCount(failure) {
  return {
    type: 'UPDATE_API_FAIL_COUNT',
    failure
  }
}
